<div class="row wrapper" *ngIf="album && !loading && validDownload">

  <!-- IMAGE -->
  <div class="col-md-3">
    <div class="image">
      <img [src]="album.image">
    </div>
  </div>

  <!-- METADATA -->
  <div class="col-md-4 metadata dark-color">
    <div>{{ album.artist }}</div>
    <div class="album-title">{{ album.title }}</div>
    <div *ngIf="album.catalogNum">{{ album.catalogNum }}</div>
  </div>

  <!-- DOWNLOADS -->
  <div class="col-md-5">
    <div *ngFor="let type of album.types" class="pv-button" [ngClass]="{ disabled: !type.url }">
      <span *ngIf="!type.url">{{ type.override }}</span>
      <a *ngIf="type.url" [href]="type.url" class="inner-link" (click)="download(type)">
        {{ type.override ? type.override : 'Download ' + type.type}}
      </a>
    </div>
    <div class="pv-button disabled" *ngIf="!album.types.length">
      Not Eligible For Download
    </div>
  </div>

</div>